import { apiClient, ApiError } from "@nimbus-erp/api-client";
import { useQuery } from "@tanstack/react-query";
import { useEffect, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { ERP_SESSION_CHANGE } from "../utils/sessionChange";
import { ErpLoading } from "./ErpLoading";

export function AuthBootstrap({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { user, initialized, setInitialized, setUser } = useAuthStore();
  const isLoginRoute = location.pathname === "/login";
  const meQuery = useQuery({
    queryKey: ["session"],
    queryFn: apiClient.me,
    enabled: !initialized && !isLoginRoute,
    retry: (count, error) =>
      !(error instanceof ApiError && error.status === 401) && count < 1,
  });

  useEffect(() => {
    if (initialized) return;
    if (meQuery.data) {
      setUser(meQuery.data);
      setInitialized(true);
    } else if (meQuery.isError) {
      setUser(null);
      setInitialized(true);
    }
  }, [initialized, meQuery.data, meQuery.isError, setInitialized, setUser]);

  useEffect(() => {
    const changed = (event: StorageEvent) => {if(event.key===ERP_SESSION_CHANGE) window.location.reload();};
    window.addEventListener("storage",changed);
    return ()=>window.removeEventListener("storage",changed);
  },[]);
  if (isLoginRoute) return children;
  if (!initialized) {
    return (
      <ErpLoading
        mode="session"
        label="正在恢复会话"
        title="正在进入企业工作台"
        description="校验租户、套餐与权限配置"
      />
    );
  }
  if (!user)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search + location.hash }} />;
  if (user.loginType !== "ERP") return <Navigate to="/login" replace />;
  return children;
}
